module.exports = __webpack_public_path__ + "media/whatDoYouNeed2.166bf50e.mp3";